import {OAuthResourceServerErrorHandler} from 'angular-oauth2-oidc';
import {HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

export class OAuthCustomResourceServerErrorHandler
  implements OAuthResourceServerErrorHandler {
  handleError(err: HttpResponse<any>): Observable<any> {
    if (err.status === 401 && !err.url.includes('/api/v1/moderator-token')) {
      location.reload();
    }
    return throwError(err);
  }
}
